<template>
  <v-tabs v-model="item.data.activeTab || 0" color="primary">
    <v-tab>General</v-tab>
    <v-tab @change="getContacts()">Contacts</v-tab>
    <v-tab>Offers</v-tab>
    <v-tab>Accounting</v-tab>
    <v-tab @change="getNotesList">Notes</v-tab>
    <v-tab @change="getPostbacks()">Postback</v-tab>
    <v-tab @change="getAdvertiserVerticals" >verticals</v-tab>
    <v-tab-item :key="`advetiser-${item.data.id || item.data.advertiser_id}-general`">
      <v-progress-linear v-show="preloaderChart"
                         indeterminate
      ></v-progress-linear>
      <v-container fluid>
        <v-row align="center">
          <v-col cols="12" sm="6" class="py-0">
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field label="ID" hide-details readonly disabled :value="item.data.id || item.data.advertiser_id"></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field label="Email" hide-details readonly disabled :value="item.data.email"></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field label="Name" hide-details v-model="name" :readonly="item.data.readOnly"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-select hide-details label="Manager" :readonly="item.data.readOnly"
                          ref="status"
                          :items="managers"
                          v-model="managerId"
                ></v-select>
              </v-col>
            </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-select hide-details label="Status" :readonly="item.data.readOnly"
                    :items="[
                        {value: 'active', text: 'Active'},
                        {value: 'inactive', text: 'Inactive'},
                        {value: 'rejected', text: 'Rejected'},
                        {value: 'pending', text: 'Pending'},
                    ]"
                    v-model="status"
                ></v-select>
              </v-col>
            </v-row>
              <v-row align="center" class="mt-0">
                  <v-col cols="12" md="6">
                      <v-select
                          label="Billing Cycle"
                          hide-details
                          :items="['weekly', 'semimonthly', 'monthly']"
                          v-model="item.data.billingCycle"
                      ></v-select>

                  </v-col>
              </v-row>
            <v-row align="center" class="mt-0">
              <v-col cols="12" md="6">
                <v-text-field label="Date Added" hide-details readonly disabled :value="item.data.dateAdded"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row align="center" class="mt-0" v-if="user[0].can('edit_payin_payout')">
          <v-col cols="6" md="6">
            <v-text-field label="Margin" v-model="margin" :rules="[rules.required, rules.float, rules.positive]" suffix="%" :value="item.data.margin" :readonly="item.data.readOnly">
            </v-text-field>
          </v-col>
        </v-row>
        <v-btn
                v-if="!checkInputsNotChanged()"
                fixed
                top
                right
                style="top: 50px"
                color="primary"
                :loading="updating"
                :disabled="updating"
                class="upd-btn ma-0"
                @click="onUpdate"
        >
          Update
        </v-btn>
        <v-row>
          <v-col cols="12" md="3" class="pb-0">
            <v-select hide-details label="Trends" v-model="chartOptions.chartPeriod" :items="[{value: 7, text: 'Last 7 Days'}]"></v-select>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-skeleton-loader :loading="chartLoading" class="mx-auto mt-3" width="100%" height="250px" type="image">
              <v-alert color="warning" v-if="chartError">
                {{chartError}}
              </v-alert>
              <apexchart v-else type="line" height="250px" :options="chartOptions"  :series="series"></apexchart>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </v-tab-item>
    <v-tab-item :key="`advetiser-${item.data.id || item.data.advertiser_id}-contacts`">
      <v-progress-linear v-show="contactTab.isLoading" indeterminate />
      <v-container fluid>
        <template v-if="this.contactTab.items">
          <v-row>
            <v-col cols="12">
              <strong>Contacts:</strong>
            </v-col>
            <v-col cols="12">
              <v-btn
                v-if="isAdvertiserContactsChanged"
                fixed
                top
                right
                style="top: 50px"
                color="primary"
                class="upd-btn ma-0"
                @click="onUpdateAdvertiserContacts"
              >
                Update
              </v-btn>
            </v-col>
          </v-row>
          <template>
            <div>
              <v-row v-for="(contact, index) in contactTab.items" :key="`affiliate-${item.data.id}-contact-${index}`" align="center">
                <v-col cols="6">
                  <v-text-field v-model="contactTab.items[index].email" label="Email" :error-messages="errors[index]"></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-radio-group v-model="contactTab.items[index].isPrimary" @change="setPrimaryContact(index)" row>
                    <v-radio :label="contact.isPrimary ? 'Primary' : ''" :value="true"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="3" class="d-flex justify-space-between align-center" v-if="!contact.isPrimary">
                  <v-btn color="primary" icon @click="confirmDeleteContact(index)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

<!--              <v-dialog v-model="contactTab.dialog" max-width="500px">-->
<!--                <v-card>-->
<!--                  <v-card-title class="headline">Confirm Deletion</v-card-title>-->
<!--                  <v-card-text>Are you sure you want to delete this contact?</v-card-text>-->
<!--                  <v-card-actions>-->
<!--                    <v-spacer></v-spacer>-->
<!--                    <v-btn color="green darken-1" text @click="dialog = false">Cancel</v-btn>-->
<!--&lt;!&ndash;                    <v-btn color="green darken-1" text @click="deleteContact(selectedContactIndex)">Confirm</v-btn>&ndash;&gt;-->
<!--                  </v-card-actions>-->
<!--                </v-card>-->
<!--              </v-dialog>-->
            </div>
          </template>

          <v-row>
            <v-col cols="12">
              <v-btn color="primary" class="white--text"  @click="addContact">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <br>
<!--              <span v-if="validation.length > 0" class="red&#45;&#45;text">{{ validation.join(', ') }}</span>-->
            </v-col>

          </v-row>
        </template>
      </v-container>
    </v-tab-item>
    <v-tab-item :key="`advertiser-${item.data.id || item.data.advertiser_id}-offers`">
      <v-progress-linear v-show="preloaderOffers"
                         indeterminate
      ></v-progress-linear>
      <v-container fluid class="pa-0">
        <v-skeleton-loader :loading="offersLoading" class="mb-2 mx-auto" max-width="100%" max-height="320px"
                           type="table-thead, table-tbody">
          <v-data-table
              :headers="cardOffers.headers"
              :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
              :items="cardOffers.items"
              :footer-props="{itemsPerPageOptions: cardOffers.pageOptions}"
              :page="1"
              :items-per-page="10"
              loading-text="Loading... Please wait"
              fixed-header
              :class="`elevation-0 mb-0 co-data-table items-size-45`"
              item-class="td_title"
              color="#7F98A5"
          >
            <template v-for="item of cardOffers.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
              <span class="header_title">{{header.text}}</span>
            </template>
            <template v-for="header of cardOffers.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
              <template v-if="header.value === 'currencyId'">
                <v-tooltip top open-delay="400">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{item.currencySymbol}}</span>
                  </template>
                  <span>{{item.currencyName}}</span>
                </v-tooltip>
              </template>
              <template v-else>{{item[header.value]}}</template>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </v-container>
    </v-tab-item>
    <v-tab-item :key="`advertiser-${item.data.id || item.data.advertiser_id}-accounting`">
      <v-progress-linear v-show="preloaderAccounting"
                         indeterminate
      ></v-progress-linear>
      <v-container fluid class="pa-0">
        <v-skeleton-loader
          :loading="accountingLoading"
          class="mb-2 mx-auto"
          max-width="100%" max-height="320px"
          type="table-heading@4"
        >
          <v-data-table
              :headers="advertiserPayments.headers"
              :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
              :items="advertiserPayments.items"
              :footer-props="{itemsPerPageOptions: advertiserPayments.pageOptions}"
              :page="1"
              :items-per-page="10"
              loading-text="Loading... Please wait"
              fixed-header
              :class="`elevation-0 mb-0 co-data-table items-size-45`"
              item-class="td_title"
              color="#7F98A5"
          >
            <template v-for="item of advertiserPayments.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
              <span class="header_title">{{header.text}}</span>
            </template>
            <template v-for="header of advertiserPayments.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
                <template v-if="header.value === 'amount' || header.value === 'revenue'">
                  <span>{{ item.symbol }} {{ item[header.value] }} </span>
                </template>
                <template v-else>{{ item[header.value] }}</template>
            </template>
          </v-data-table>
        </v-skeleton-loader>
      </v-container>
    </v-tab-item>
    <v-tab-item :key="`advertiser-${item.data.id || item.data.advertiser_id}-note`">
      <v-progress-linear
        v-show="noteTab.isLoading"
        indeterminate
      />
      <v-container fluid class="pa-0">
        <div class="d-flex justify-space-between px-3 align-content-center">
          <h2 class="mb-0">Notes</h2>
          <NoteModal :affiliate="item.data" :user="user[0]" @submitNote="createNote"/>
        </div>
        <v-data-table
            :headers="noteTab.headers"
            :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
            :items="noteTab.items"
            :footer-props="{itemsPerPageOptions: noteTab.pageOptions}"
            :page="1"
            :items-per-page="25"
            loading-text="Loading... Please wait"
            fixed-header
            :class="`elevation-0 mb-0 co-data-table items-size-45`"
            item-class="td_title"
            color="secondary"
        >
          <template  v-slot:item.dateAdded="{ item }">
            {{item.dateAdded}}
            <div>
              <NoteEditModal :note="item" :user="user[0]" @editNote="editNote"/>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <button
                      v-bind="attrs"
                      v-on="on"
                      @click="editNote({ ...item, isDeleted: true })"
                      :disabled="user[0].email !== item.email"
                      class="td_title btn btn-link"
                  >
                    <i class="far fa-trash"></i>
                  </button>
                </template>
                <span>Delete Note</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-container>
    </v-tab-item>
    <v-tab-item :key="`advertiser-${item.data.id || item.data.advertiser_id}-postback`">
      <v-progress-linear
              v-show="postbackTab.isLoading"
              indeterminate
      />
      <v-container fluid class="pa-10">
        <v-row>
          <v-col cols="8" sm="8">
          </v-col>
          <v-col cols="4" sm="4" class="d-flex justify-end">
            <v-btn :disabled="postbackTab.isUpdateDisabled" @click="updatePostback">
              Update
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="postbackTab.headers"
          :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
          :items="postbackTab.items"
          :items-per-page="5"
          :hide-default-footer="true"
          loading-text="Loading... Please wait"
          fixed-header
          :class="`elevation-0 mb-0 co-data-table items-size-45`"
          color="secondary"
          item-class="м"
        >
          <!-- body -->
          <template v-for="header of postbackTab.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
            <template v-if="header.value === 'url'">
              <v-text-field
                :disabled="true"
                class="centered-input"
                v-model="item[header.value]"
                multi-line
              ></v-text-field>
            </template>
            <template v-else-if="header.value === 'eventType'">
              <v-select
                v-model="item[header.value]"
                :items="postbackTab.selectEvents"
                item-value="eventType"
                item-text="eventType"
                style="max-width: 200px;"
                @change="postbackChanged"
              ></v-select>
            </template>
            <template v-else-if="header.value === 'isDefault'">
                <v-radio-group v-model="defaultId" @change="setDefault(item.id)">
                  <v-radio :value="item.id"></v-radio>
                </v-radio-group>
            </template>
            <template v-else="header.value === 'actions'">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="deletePostback(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Remove</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <span
                        @click="copyLink(item.url)"
                        v-clipboard:copy="item.url"
                        class="td_title"
                        v-bind="attrs"
                        v-on="on"
                >
                  <v-icon size="16" color="#7F98A5" style="cursor:pointer;">mdi-content-copy</v-icon>
                </span>
                </template>
                <span>Copy URL</span>
              </v-tooltip>
            </template>
          </template>
        </v-data-table>
        <v-row class="mt-10">
          <v-col cols="2" sm="3">
            <v-select
              v-model="postbackTab.newEventType"
              :items="postbackTab.selectEvents"
              item-value="eventType"
              item-text="eventType"
              style="max-width: 200px;"
              label="EventType"
            ></v-select>
          </v-col>
          <v-col cols="3" sm="3">
            <v-btn class="addPostback" @click="addNewPostback()">Add</v-btn>
          </v-col>
          <v-col cols="6" sm="6">
          </v-col>
        </v-row>

        <v-row>
          <v-data-table
                  :headers="postbackTab.paramHeaders"
                  :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
                  :items="postbackTab.paramItems"
                  :items-per-page="5"
                  :hide-default-footer="true"
                  loading-text="Loading... Please wait"
                  fixed-header
                  :class="`elevation-0 mb-0 co-data-table items-size-45`"
                  color="secondary"
                  item-class="м"
                  style="width: 100%"
          >
            <template v-for="header of postbackTab.paramHeaders" :slot="`item.${[header.value]}`" slot-scope="{item}">
              <template>
                <div class="d-flex justify-center">
                  {{item[header.value]}}
                </div>
              </template>
              <template v-if="header.value === 'actions'">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="deleteParam(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Remove</span>
                </v-tooltip>
              </template>
            </template>
            <template v-slot:body.append>
              <tr style="background-color: white;" class="no-hover-background">
                <td style="padding-left:0; padding-top: 10px">
                  <v-text-field v-model="postbackTab.newParam.key_value" dense></v-text-field>
                </td>
                <td td style="padding-left:0; padding-top: 10px">
                  <v-text-field v-model="postbackTab.newParam.rename_to" dense></v-text-field>
                </td>
                <td class="text-center">
                  <v-btn icon color="primary" @click="addNewParam">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-row>
      </v-container>
    </v-tab-item>
    <v-tab-item :key="`advertiser-verticals-${item.data.id || item.data.advertiser_id}`">
      <div style="margin-top: 30px; height: 600px;">
        <v-container>
          <v-progress-linear v-show="preloaderVerticals" indeterminate></v-progress-linear>

          <v-autocomplete
              v-model="selectedVerticals"
              :items="allVerticals"
              item-value="id"
              item-text="name"
              multiple
              chips
              small-chips
              :menu-props="{ maxHeight: '400px' }"
              class="custom_autocomplete"
              @change="updateSelectedVerticals"
              :search-input.sync="searchTerm"
              @keyup.enter="addNewVertical"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                  small
                  label
                  close
                  @click:close="removeVertical(index)"
              >
                {{ item.name }}
              </v-chip>
            </template>
            <template v-slot:no-data>
              <span>Press enter to create new item</span>
            </template>
          </v-autocomplete>

          <v-btn @click="updateAction" color="primary" class="my-3" :disabled="isUpdateDisabled">Update</v-btn>

          <div v-if="error" class="error-message">{{ error }}</div>
        </v-container>
      </div>
    </v-tab-item>



  </v-tabs>
</template>

<script>
import offersApi from "@/api/offers";
import offerApi from "@/api/offer";
import affiliates from "@/api/affiliates";
import { DateTime } from "luxon";
import reports from "@/api/reports";
import advertisers from "@/api/advertisers";
import { mapGetters, mapState, mapActions } from 'vuex'
import store from '@/store';
import { createPeriod } from "@/helpers";
import NoteModal from './NoteModal';
import NoteEditModal from './NoteEditModal';
import affiliatesApi from "@/api/affiliates";

export default {
  props: {
    item: {
      type: Object
    },
  },
  components: {
    NoteModal,
    NoteEditModal
  },
  async mounted() {
    console.log('card mounted', this.item);
    if(!this.getSflAdvertisersManagers.length) {
      await store.dispatch('advertisers/saveSflAdvertisersManagersStore');
    }

    this.managers = this.getSflAdvertisersManagers.map( manager => ({
      value: manager.id, text: `${manager.firstName} ${manager.lastName}`
    }));

    setTimeout(() => {
      this.chartLoading = false
    }, 3000);
    // get advertiser sales
    await this.getAdvertiserSales()
    // get advertiser offers
    await this.getAdvertiserOffers();
    // get advertiser bills
    await this.getAdvertiserPayments();

    await this.$store.dispatch('verticals/saveVerticalsStore')

  },
  methods: {
    ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),

    async getAdvertiserOffers() {
      this.offersLoading = true;
      this.preloaderOffers = true;
      const result = await offersApi.getSflOffers(
          {
            payload: {
              filters: {
                advertiserName: `${
                    this.item.data.advertiserId ? this.item.data.advertiserId : this.item.data.id
                }`
              }
            }
          }
      );
      this.cardOffers.items = result.data;
      this.offersLoading = false;
      this.preloaderOffers = false;
    },

    async getAdvertiserSales() {
      this.offersLoading = true;
      this.preloaderChart = true;
      const period = {
        fromDate: DateTime.utc().startOf('day').minus({days: this.chartOptions.chartPeriod}).toSeconds(),
        toDate: DateTime.utc().startOf('day').toSeconds()
      };
      const filter = [{field: 'advertiser_id', value: [this.item.data.id || this.item.data.advertiser_id]}]
      const platform = await affiliates.getPlatform() || 1;
      const params = {
        entity: 'day',
        select: ['day', 'conversions'],
        filter: filter,
        ...period,
        groupBy: 'day',
        orderBy: 'day',
        orderDirectionAsc: false,
        page: 1,
        limit: 100,
        isChart: true,
        platform
      };

      let result;

      try {
        result = await reports.getDrillDownReports(params);
      } catch (error) {
        this.chartError = error;
        this.offersLoading = false;
        this.preloaderChart = false;
      }

      const { dates, conversions } = createPeriod(result, this.chartOptions.chartPeriod);

      this.chartOptions = {...this.chartOptions, ...{
          xaxis: {
            categories: dates
          }
        }}
      this.series = [{
        data: conversions
      }];
      this.chartLoading = false
      this.preloaderChart = false
    },

    async getAdvertiserPayments() {
      this.accountingLoading = true;
      this.preloaderAccounting = true;
      const advertiserPayments = await advertisers.getPayments(
          {advertiser_id: this.item.data.id || this.item.data.advertiser_id}
      );
      this.advertiserPayments = {...this.advertiserPayments, ...{items: advertiserPayments}}
      this.accountingLoading = false;
      this.preloaderAccounting = false;
    },
    updateSelectedVerticals(selectedItems) {
      this.error ='';
      console.log('isUpdateDisabled', JSON.stringify(this.originVerticals), JSON.stringify(this.selectedVerticals))
      // this.isUpdateDisabled =  JSON.stringify(this.originVerticals) === JSON.stringify(this.selectedVerticals);
      console.log('updateSelectedVerticals',this.affiliateVerticalsAll)
    },
    addNewVertical() {
      if (this.searchTerm && !this.filteredVerticals.some(v => v.name === this.searchTerm)) {
        this.affiliateVerticalsAll.unshift({ name: this.searchTerm });
        this.newItems.push(this.searchTerm);
        this.selectedVerticals.push(this.searchTerm);
        this.searchTerm = '';
      } else if (this.searchTerm) {
        this.error = 'This vertical already exists';
      }
    },
    removeVertical(index) {
      this.selectedVerticals.splice(index, 1);
    },
    async getAdvertiserVerticals() {
      this.verticalsLoading = true;
      this.preloaderVerticals = true;

      try {
        // Load all available verticals
        const allVerticals = await this.getVerticals;
        console.log('allVerticals', allVerticals);

        // Load advertiser-specific verticals
        const advertiserVerticals = await advertisers.getAdvertiserVerticals({
          advertiser_id: this.item.data.id || this.item.data.advertiser_id,
        });

        // Set all available verticals and pre-select advertiser verticals
        this.allVerticals = allVerticals;
        this.selectedVerticals = advertiserVerticals.map(v => v.verticalId);
        this.originVerticals = advertiserVerticals.map(v => v.verticalId);

        console.log('advertiserVerticals', advertiserVerticals);
      } catch (error) {
        console.error('Error fetching advertiser verticals:', error);
      } finally {
        this.verticalsLoading = false;
        this.preloaderVerticals = false;
      }
    },
    async updateAction(){
      const addedVerticals = this.selectedVerticals.filter(vertical => !this.originVerticals.includes(vertical));
      const removedVerticals = this.originVerticals.filter(vertical => !this.selectedVerticals.includes(vertical));
      const data  = {
        id: this.item.data.id,
        added: addedVerticals,
        removed: removedVerticals,
        newItems: this.newItems,
        toSave: this.selectedVerticals,
        origin: this.originVerticals
      }
      const selectedVerticalsObject = [];
      this.selectedVerticals.forEach((selectedVertical) => {
        const foundVertical = this.affiliateVerticalsAll.find((affiliateVertical) => {
          return affiliateVertical.name === selectedVertical;
        });

        if (foundVertical) {
          selectedVerticalsObject.push({
            "id": foundVertical.id,
            "name": selectedVertical
          });
        }
      });

      const isSuccess = await affiliatesApi.updateAffiliateVerticals(data);
      if (isSuccess){
        await store.dispatch('alert/ALERT_SUCCESS', `Verticals updated successfully`, {root: true});
        this.originVerticals = this.selectedVerticals.map(vert=>(vert));
        this.newItems = [];
        const vertical =  {
          affiliateId: this.item.data.id,
          verticals: selectedVerticalsObject,
        }
        await this.saveAffiliateProfileVerticals(vertical);
      } else {
        await store.dispatch('alert/ALERT_ERROR', `Verticals updated got error.`, {root: true});
      }

    },

    checkInputsNotChanged() {
      return this.status == this.item.data.status &&
             this.name == this.item.data.name &&
             this.managerId == this.item.data.advertiserManagerId &&
             this.billingCycle == this.item.data.billingCycle &&
             this.margin === this.item.data.margin
    },

    async onUpdate() {
      if(!this.margin && this.margin !== 0 || this.margin < 0 || isNaN(this.margin)) return;
      this.updating = true;
      const updatedData = {
        id: this.item.data.id,
        status: this.status,
        name: this.name,
        margin: this.margin,
        managerId: this.managerId,
        verified: this.item.data.verified,
        billingCycle: this.item.data.billingCycle
      };
      await store.dispatch('advertiser/updateSflAdvertiser', updatedData);

      this.updating = false;


      store.dispatch('alert/ALERT_SUCCESS', `Advertiser has been updated`, {root: true});
      store.dispatch('cards/REMOVE', `advertiser-${this.item.data.id}`)

      setTimeout(() => {
        store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
      }, 3000);

    },
    async getNotesList() {
      this.noteTab.isLoading = true;
      try {
        this.noteTab.items = await advertisers.getNotesList(this.item.data.id);
      } catch (e) {
        console.error(e);
        store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
      }
      this.noteTab.isLoading = false;
    },
    async getPostbacks() {
      this.postbackTab.isLoading = true;
      const res = await offerApi.getPostback(this.item.data.id);
      this.postbackTab.baseUrl = res && res.value ? res.value : '';

      try {
        this.postbackTab.items = await advertisers.getPostbacks(this.item.data);
        this.postbackTab.paramItems = await advertisers.getParams(this.item.data);
        this.postbackTab.initialParams = [...this.postbackTab.paramItems];

        this.postbackTab.initialItems = [...JSON.parse(JSON.stringify(this.postbackTab.items))];

        const initialDefaultId = this.postbackTab.items.find(i => i.isDefault === 1);
        this.defaultId = initialDefaultId ? initialDefaultId.id: 0;
        this.postbackTab.selected = initialDefaultId ? [initialDefaultId.id] : [];

      } catch (e) {
        console.error(e);
        store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
      }
      this.postbackTab.isLoading = false;
    },
    async getContacts() {
      this.contactTab.isLoading = true;

      try {
          this.contactTab.items = await advertisers.getContacts(this.item.data);
          this.contactTab.initialContacts = [...this.contactTab.items];
      } catch (e) {
          console.error(e);
          store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
      }
      this.contactTab.isLoading = false;
    },
    setPrimaryContact(selectedIndex) {
      this.contactTab.items = this.contactTab.items.map((contact, index) => {
          return {
              ...contact,
              isPrimary: index === selectedIndex
          }
      });
    },
    confirmDeleteContact(selectedIndex) {
       this.contactTab.items = this.contactTab.items.filter((contact, index) => {
            if (selectedIndex !== index) {
                return contact;
            }
       });
    },
    addContact()  {
      this.contactTab.items.push({ email: '', isPrimary: false });
    },
    async onUpdateAdvertiserContacts() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.contactTab.items.forEach((item, index) => {
        if (!emailPattern.test(item.email)) {
          this.$set(this.errors, index, 'Please enter a valid email address.');
          setTimeout(() => {
            this.$set(this.errors, index, '');
          }, 3000);
        }
      });
      await advertisers.insertOrUpdateAdvertiserContacts(this.item.data.id, this.contactTab.items);
    },
    addNewPostback() {
      const maxId = this.postbackTab.items.length
              ? this.postbackTab.items.map(i => i.id).reduce((a, b) => Math.max(a, b), -Infinity)
              : 0
      this.postbackTab.items.push({
        id: maxId + 1,
        url: `${this.postbackTab.baseUrl}&event=${this.postbackTab.newEventType}`,
        eventType: this.postbackTab.newEventType,
        isDefault: 0,
        status: 'new',
      });
      this.postbackTab.newUrl = '';
      this.postbackTab.newEventType = '';
      this.postbackChanged();

      console.log(this.postbackTab.items);

    },

    deletePostback(itemToDelete) {
      this.postbackTab.items = this.postbackTab.items.filter(item => item.id !== itemToDelete.id);
      this.postbackTab.deletedIds.push(itemToDelete.id);
      this.postbackChanged();
    },

    deleteParam(itemToDelete) {
      this.postbackTab.paramItems = this.postbackTab.paramItems.filter(item => item.key_value !== itemToDelete.key_value);
      this.postbackChanged();
    },

    setDefault(id) {
      this.postbackTab.items.forEach(item => {
        item.isDefault = item.id === id;
      });
      this.defaultId = id;
      this.postbackChanged();
    },

    postbackChanged() {
      this.postbackTab.isUpdateDisabled = JSON.stringify(this.postbackTab.initialItems) === JSON.stringify(this.postbackTab.items)
        && JSON.stringify(this.postbackTab.initialParams) === JSON.stringify(this.postbackTab.paramItems)
    },
    async updatePostback() {
      this.postbackTab.items = this.postbackTab.items.map(p => {
        p.advertiserId = this.item.data.id;
        p.isDefault = p.isDefault ? 1 : 0;
        return p;
      });
      await advertisers.updatePostbackItems(this.postbackTab.items, this.postbackTab.deletedIds, this.item.data.id);

      await advertisers.updateParams(this.postbackTab.paramItems, this.item.data.id);
    },

    async copyLink(url) {
      this.ALERT_SUCCESS('Link Copied');

      await navigator.clipboard.writeText(url)

      setTimeout(()=>{
        this.ALERT_SUCCESS('');
      },3500)
    },

    async createNote(data) {
      try {
        await advertisers.createNote(data);
        this.getNotesList();
        store.dispatch('alert/ALERT_SUCCESS', `Note has been created`, {root: true});
      } catch (e) {
        store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
      }

      setTimeout(() => {
        store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
      }, 3000);
    },
    async editNote(data) {
      try {
        console.log(data)
        if (data.isDeleted) {
          await advertisers.updateNote({id: data.id, note: data.note, isDeleted: true});
        } else {
          await advertisers.updateNote(data);
        }
        this.getNotesList();
        store.dispatch('alert/ALERT_SUCCESS', `Note was updated`, {root: true});
      } catch (e) {
        console.error(e.message)
        store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
      }

      setTimeout(() => {
        store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
      }, 3000);
    },

    addNewParam() {
      if (this.postbackTab.newParam.key_value) {
        const isDuplicate = this.postbackTab.paramItems.some(
                item => item.key_value === this.postbackTab.newParam.key_value
        );

        if (!isDuplicate) {
          this.postbackTab.paramItems.push({ ...this.postbackTab.newParam });
        }

        this.postbackTab.newParam.key_value = '';
        this.postbackTab.newParam.rename_to = '';
      }
      this.postbackChanged();
    }
  },
  computed: {
    ...mapGetters('advertisers', ['getSflAdvertisersManagers']),
    ...mapState('user', ['user']),
    ...mapGetters('verticals', ['getVerticals']),
    isAdvertiserContactsChanged() {
      return JSON.stringify(this.contactTab.initialContacts) !== JSON.stringify(this.contactTab.items);
    },
    isUpdateDisabled() {
      return JSON.stringify(this.originVerticals) === JSON.stringify(this.selectedVerticals);
    },
  },
  name: "AdvertiserCard",
  data() {
    return {
      defaultId: 0,
      managers: [],
      errors: [],
      managerId: this.item.data.advertiserManagerId,
      name: this.item.data.name,
      status: this.item.data.status,
      margin: this.item.data.margin,
      billingCycle: this.item.data.billingCycle,
      updating: false,
      preloaderChart: false,
      preloaderOffers: false,
      preloaderAccounting: false,
      chartLoading: true,
      offersLoading: true,
      accountingLoading: true,
      verticalsLoading: true,
      preloaderVerticals: true,
      advertiserVerticals: [],
      searchTerm: "",
      error: "",
      selectedVerticals: [],
      originVerticals: [],
      allVerticals: [],
      selectedVertical:[],
      chartError: '',
      marginRequiredError: 'Please set the Advertiser margin before saving.',
      rules: {
        required: value => !!value || this.marginRequiredError,
        float: value => {
          const pattern = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/
          return pattern.test(value) || 'Invalid value'
        },
        positive: value => Number(value) >= 0 || 'Must be positive or 0'
      },
      cardOffers: {
        headers: [
          {text: 'ID', align: 'start', value: 'id'},
          {text: 'Name', value: 'name'},
          {text: 'Status', value: 'status', align: 'center'},
          {text: 'Payin', value: 'payIn', align: 'center'},
          {text: 'Payout', value: 'payOut', align: 'center'},
          {text: 'Currency', value: 'currencyId', align: 'center'},
          {text: 'Vertical', value: 'verticalName'},
          {text: 'URL', value: 'landingPageUrl'},
        ],
        items: [],
        pageOptions: [10, 25, 50, 100],
      },
      advertiserPayments: {
        headers: [
          { text: 'Status', value: 'status', align: 'center' },
          { text: 'Billing Cycle', value: 'billing_cycle', align: 'center' },
          { text: 'Start Period', value: 'start_period', align: 'center' },
          { text: 'End Period', value: 'end_period', align: 'center' },
          { text: 'Amount', value: 'amount', align: 'center' },
          { text: 'Revenue', value: 'revenue', align: 'center' },
        ],
        items: [],
        pageOptions: [10, 25, 50, 100],
      },
      noteTab: {
        isLoading: true,
        headers: [
          {text: 'Author', value: 'author', class: 'color', align: 'center'},
          {text: 'Author Email', value: 'email', class: 'color', align: 'center'},
          {text: 'Note', value: 'note', class: 'color', align: 'center'},
          {text: 'Date Added', value: 'dateAdded', align: 'center'},
        ],
        items: [],
        pageOptions: [10, 25, 50, 100],
      },
      postbackTab: {
        isLoading: true,
        baseUrl: '',
        isUpdateDisabled: true,
        selected: [],
        paramHeaders: [
          {text: 'Key', value: 'key_value', class: 'color', align: 'center', width: '30%'},
          {text: 'Rename to', value: 'rename_to', class: 'color', align: 'center', width:'50'},
          {text: 'Actions', value: 'actions', class: 'color', align: 'center', width: '20%'}
        ],
        headers: [
          {text: 'URL', value: 'url', class: 'color', align: 'left', width: '50%'},
          {text: 'Event Type', value: 'eventType', class: 'color', align: 'left', width:'30'},
          {text: 'Default', value: 'isDefault', class: 'color', align: 'start', width:'10%'},
          {text: 'Actions', value: 'actions', class: 'color', align: 'center', width: '10%'}
        ],
        selectEvents: [
          {eventType: 'conversion'},
          {eventType: 'registration'},
          {eventType: 'installation'},
          {eventType: 'click'},
          {eventType: 'sale'},
        ],
        items: [],
        newParam: {
          key_value: '',
          rename_to: ''
        },
        paramItems: [],
        initialParams: [],
        initialItems: [],
        deletedIds: [],
        newUrl: '',
        newEventType: '',
        pageOptions: [10, 25, 50, 100],
      },
      contactTab: {
          isLoading: true,
          dialog: false,
          items: [],
          initialContacts: [],
      },
      chartOptions: {
        chartPeriod: 7,
        chart: {
          id: `advertiser-${this.item.data.id || this.item.data.advertiser_id}-chart`,
          toolbar: {
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false
            }
          },
        },
        xaxis: {
          categories: []
        },
        colors: [this.$vuetify.theme.themes.light.primary],
      },
      series: [
        {
          name: 'Conversions',
          data: []
        },
      ],
    }
  }
}
</script>

<style scoped lang="sass">
  .inner-container
    padding-left: 5% !important
  .addPostback
    margin-top: 10px !important
  .uniform-background
    background-color: white !important
  .v-select__selection
    width: 100% !important
    justify-content: center !important
  .centered-input ::deep input
    text-align: center !important
  div.v-input__control
    margin-left: 25% !important
  .v-data-table-header::deep th
    white-space: nowrap !important
    padding-left: 15% !important
  .no-hover-background
    background-color: white !important
  .no-hover-background:hover,.v-data-table__row--active.no-hover-background
    background-color: white !important


</style>
